import { render, staticRenderFns } from "./AreaEditModal.vue?vue&type=template&id=5c01e5a0&"
import script from "./AreaEditModal.vue?vue&type=script&lang=ts&"
export * from "./AreaEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports